import { render } from "./product-pvp.vue?vue&type=template&id=69afd37a"
import script from "./product-pvp.vue?vue&type=script&lang=js"
export * from "./product-pvp.vue?vue&type=script&lang=js"
script.render = render

export default script